module.exports = __webpack_public_path__ + "img/icon-meeting.fea655d9.svg";